import { render, staticRenderFns } from "./searchIcon.vue?vue&type=template&id=6b4fbee6&"
import script from "./searchIcon.vue?vue&type=script&lang=js&"
export * from "./searchIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports